import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import type { ReactElement } from 'react';

import { CategoryRow } from './CategoryRow';

export type LeafItem = {
    uuid: string;
    label: string;
};

export type SubCategoryDropdownProps = {
    label: string;
    count: number;
    items?: LeafItem[];
    open?: boolean;
    checked?: boolean;
    indeterminate?: boolean;
    selected?: string[];
    dense?: boolean;
    onToggleOpen?: () => void;
    onToggleChecked?: () => void;
    onToggleItem?: (uuid: string) => void;
    disabled?: boolean;
};

export function SubCategoryDropdown({
    label,
    count,
    items = [],
    open = false,
    checked = false,
    indeterminate = false,
    selected = [],
    dense = false,
    onToggleOpen,
    onToggleChecked,
    onToggleItem,
    disabled,
}: SubCategoryDropdownProps): ReactElement {
    // Hide the chevron when there are no leaf items to expand into.
    const expandHandler = items.length > 0 ? onToggleOpen : undefined;

    return (
        <Box>
            <Divider />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    pl: 3,
                    py: dense ? 0 : 1,
                }}>
                <CategoryRow
                    label={`${label} (${count})`}
                    checked={checked}
                    indeterminate={indeterminate}
                    open={open}
                    onChange={onToggleChecked}
                    onToggleOpen={expandHandler}
                    disabled={disabled}
                />
            </Box>
            {open && (
                <Box sx={{ pl: 7 }}>
                    {items.map((item) => (
                        <FormControlLabel
                            key={item.uuid}
                            control={
                                <Checkbox
                                    checked={selected.includes(item.uuid)}
                                    onChange={() => onToggleItem?.(item.uuid)}
                                    disabled={disabled}
                                />
                            }
                            label={item.label}
                            sx={{ display: 'flex', mr: 0 }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
}
